var _path, _path2, _path3, _path4, _circle, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceipt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 12H23",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16L17 16",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20H19H11",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24C5.44772 24 5 24.4477 5 25L5 26C5 27.6569 6.34315 29 8 29L22 29L22 25C22 24.4477 21.5523 24 21 24L6 24Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 20,
    r: 1,
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 4H27C27 3.62091 26.7856 3.27441 26.4464 3.10518C26.1072 2.93594 25.7015 2.97307 25.3986 3.20106L26 4ZM21.0703 7.71094L20.3966 8.44991L21.0093 9.00853L21.6717 8.50987L21.0703 7.71094ZM17 4L17.6737 3.26102C17.2917 2.91275 16.7072 2.91302 16.3256 3.26167L17 4ZM12.9375 7.71094L12.3367 8.51033L12.9996 9.00859L13.6119 8.44927L12.9375 7.71094ZM8 4L8.60081 3.20061C8.29788 2.97293 7.89227 2.93604 7.55324 3.10535C7.21421 3.27465 7 3.62105 7 4H8ZM22 30H23V28H22V30ZM27 26V4H25V26H27ZM25.3986 3.20106L20.4689 6.912L21.6717 8.50987L26.6014 4.79894L25.3986 3.20106ZM21.744 6.97196L17.6737 3.26102L16.3263 4.73898L20.3966 8.44991L21.744 6.97196ZM16.3256 3.26167L12.2631 6.97261L13.6119 8.44927L17.6744 4.73833L16.3256 3.26167ZM13.5383 6.91155L8.60081 3.20061L7.39919 4.79939L12.3367 8.51033L13.5383 6.91155ZM7 4V24H9V4H7ZM23 30C25.2091 30 27 28.2091 27 26H25C25 27.1046 24.1046 28 23 28V30Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/Receipt.9264648d.svg";
export { ForwardRef as ReactComponent };